export default __webpack_public_path__ + "static/media/webbooks.8ebc94d4.png";